document.addEventListener('DOMContentLoaded', function () {
  const currentHost = window.location.hostname;

  document.querySelectorAll('a[href]').forEach(function (link) {
    const href = link.getAttribute('href');

    // Skip anchors, email, phone, javascript, and empty links
    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    ) {
      return;
    }

    let linkUrl;

    try {
      linkUrl = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    // External link only
    if (linkUrl.hostname !== currentHost) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});